import { AppStyled, GlobalStyle } from '../GlobalStyle';
import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { init } from 'Libs/apollo';
import AuthStore from 'Store/AuthStore';
import UiStore from 'Store/UiStore';
import DesignStore from 'Store/DesignStore';
import InitiStore from 'Store/InitiStore';
import { BrowserRouter } from 'react-router-dom';
import ModalContainer from 'react-modal-promise';
import { MagazineIndex } from 'Components/magazine';
import { DynamicStylesExternal } from 'Components/DynamicStylesExternal';

const App = () => {
  const client = init();
  return (
    <AppStyled>
      <BrowserRouter>
        <AuthStore.Provider initialData={client}>
          <UiStore.Provider>
            <DesignStore.Provider initialData={client}>
            <ApolloProvider client={client}>
              <InitiStore />
              <>
                <DynamicStylesExternal />
                <GlobalStyle />
                <MagazineIndex />
                <ModalContainer />
              </>
            </ApolloProvider>
            </DesignStore.Provider>
          </UiStore.Provider>
        </AuthStore.Provider>
      </BrowserRouter>
    </AppStyled>
  );
};

export default App;
